import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		sectionHeader: {
			fontWeight: "bold",
			fontSize: 18,
		},
		fieldLabel: {
			color: theme.palette.text.secondary,
			fontSize: 16,
			marginBottom: 16,
			display: "flex",
			alignItems: "center",
			gap: 8,
		},
		toggleContainer: {
			display: "flex",
			flexDirection: "column",
			gap: 16,
			alignItems: "flex-start",
		},
		radioGroupStacked: {
			marginTop: 4,
			alignItems: "flex-start",
			"& .MuiFormControlLabel-root": {
				marginLeft: 0,
			},
		},
		sectionDescription: {
			color: theme.palette.text.secondary,
			marginTop: 4,
		},
		redirectCodeField: {
			fontFamily: "monospace",
			fontSize: 12,
		},
	} satisfies Record<string, CSSObject>);
};
